import { configureStore } from "@reduxjs/toolkit";
import deviceReducer from "./slices/deviceSlice";
import drawerReducer from "./slices/drawerSlice";
import firmwareVersionReducer from "./slices/firmwareVersionSlice";
import userReducer from "./slices/userSlice";
import variokeysSliceReducer from "./slices/variokeysSlice";

const store = configureStore({
  reducer: {
    device: deviceReducer,
    drawer: drawerReducer,
    user: userReducer,
    firmwareVersion: firmwareVersionReducer,
    variokeys: variokeysSliceReducer
  },
});

export type RootState = ReturnType<typeof store.getState>;

export { store };
